// extracted by mini-css-extract-plugin
export var avatarContainer = "_9p-0";
export var avatarTypingWave = "_9p-i";
export var gray = "_9p-f";
export var green = "_9p-c";
export var icon = "_9p-9";
export var image = "_9p-1";
export var lg = "_9p-6";
export var md = "_9p-5";
export var presenceDot = "_9p-b";
export var red = "_9p-d";
export var sm = "_9p-4";
export var status = "_9p-a";
export var typingDot = "_9p-h";
export var typingPill = "_9p-g";
export var xl = "_9p-7";
export var xs = "_9p-3";
export var xxl = "_9p-8";
export var xxs = "_9p-2";
export var yellow = "_9p-e";